import FormSelect from "./FormSelect";
import { SEMESTERS, T_SHIRT_SIZES } from "../config/constant";
import FormInput from "./FormInput";

const PlayerCard = ({ register, errors, index, role = "players" }) => (
  console.log("role",register(`players[${index}].role`)),

  <div className="rounded-lg border border-red-100 bg-red-50/50 p-4">
    <h3 className="mb-4 text-lg font-medium text-red-600">
      {role === "captain"
        ? "Captain"
        : role === "vice-captain"
          ? "Vice Captain"
          : `Player ${index + 1}`}
    </h3>
    <div className="grid gap-4 md:grid-cols-4">
      <FormInput
        label="Name"
        register={register(`players[${index}].name`)}
        error={errors?.players?.[index]?.name?.message}
      />
      <FormInput
        label="Role"
        register={register(`players[${index}].role`)}
        value={role}
        error={errors?.players?.[index]?.role?.message}
        disabled={true}
      />
      <FormInput
        label="Phone Number"
        type="number"
        register={register(`players[${index}].phone`)}
        error={errors?.players?.[index]?.phone?.message}
      />
      <FormInput
        label="Enrollment Number"
        register={register(`players[${index}].enrollmentNumber`)}
        error={errors?.players?.[index]?.enrollmentNumber?.message}
      />
      <FormSelect
        label="Semester"
        register={register(`players[${index}].semester`)}
        options={SEMESTERS}
        error={errors?.players?.[index]?.semester?.message}
      />
      <FormSelect
        label="T-Shirt Size"
        register={register(`players[${index}].tShirtSize`)}
        options={T_SHIRT_SIZES}
        error={errors?.players?.[index]?.tShirtSize?.message}
      />
    </div>
  </div>
);

export default PlayerCard;